"use client";
import { Config, Template } from "src/types";
import { mockConfig } from "../../constants/mockConfig";
import { useTheme } from "../../contexts/useTheme";
import { layoutComponentMap } from "../../SelectLayoutComponent";
import Skeleton from "react-loading-skeleton";
const FooterSwitch: React.FC<{ serverconfig: Config }> = ({ serverconfig }) => {
  const { config } = useTheme();
  const pageComponents = layoutComponentMap["footer"];
  const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
  if (!isDemoMode) {
    const SelectedComponent =
      pageComponents[serverconfig.template as Template] ||
      pageComponents["design1"];
    return <SelectedComponent styling={mockConfig.styling} />;
  }
  const SelectedComponent =
    pageComponents[config?.template as Template] || pageComponents["design1"];
  if (!config?.template) {
    return <Skeleton width={`100vw`} height={50} />;
  }
  return <SelectedComponent styling={mockConfig.styling} />;
};

export default FooterSwitch;
